import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	DeleteFilePreview,
	DeleteFilePreviewResponse,
} from 'domain/usecases/private/refund/request-preview';

export class RemoteDeleteFilePreview implements DeleteFilePreview {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<DeleteFilePreviewResponse>,
	) {}

	async delete(): Promise<DeleteFilePreviewResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'delete',
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
